<template>
   <component
      :is="icon"
      class="__icon stroke-[1.5]"
      :class="{ 'size-4': defaultSize, '!text-light-grey': disabled }"
   />
</template>

<script lang="ts" setup>
import { defineAsyncComponent, shallowRef, watch } from 'vue'

type Props = {
   name: string
   defaultSize?: boolean
   disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
   defaultSize: true,
})

const icon = shallowRef()

watch(
   () => props.name,
   async (newName) => {
      icon.value = defineAsyncComponent(
         () => import(`../../../../shared/assets/src/svg/${newName}.svg`)
      )
   },
   { immediate: true }
)
</script>
